import { useSelector } from 'react-redux'

import { invalidStepsSelector, selectedStepIdSelector } from '../selectors'

const useShouldPreventForwardNavigation = () => {
  const selectedStepId = useSelector(selectedStepIdSelector)
  const requiredQuestions = useSelector(invalidStepsSelector)

  return !!requiredQuestions.find(questionId => questionId === selectedStepId)
}

export default useShouldPreventForwardNavigation
